import ApiService from "./ApiService";

// options.signal permite abortar la request via AbortController (createAsyncThunk lo provee).
// Axios reconoce `signal` en config nativamente (≥ 0.22).
export async function apiGetDashboardTickets(params, options = {}) {
    const { query } = params
    return ApiService.fetchData({
        url: query,
        method: 'get',
        signal: options.signal,
    })
}

export async function apiGetHomeStats() {
    return ApiService.fetchData({
        url: '/tickets/home',
        method: 'get',
    })
}

export async function apiGetDashboardManagement(params, options = {}) {
    const { query } = params
    return ApiService.fetchData({
        url: query,
        method: 'get',
        signal: options.signal,
    })
}

export async function apiGetDashboardQuestionnaires(params, options = {}) {
    const { query } = params
    return ApiService.fetchData({
        url: query,
        method: 'get',
        signal: options.signal,
    })
}